module.exports = __webpack_public_path__ + "static/media/27OCHA10.7b326b4e.jpg";